/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from "react";
import { Button, Divider } from 'antd';
import '../../Styles/styles-Customers.css';
import { OnBoardingNav } from "../Navigation/OnBoardingNav";


function onChange(a, b, c) {
    console.log(a, b, c);
  }

  export class Customers extends React.Component{
    // state = {
    //     username:"",
    //     password: "",
    //     error: "",
    //     logged_in: false
    // }; 

    render(){
        return <>
            <div>
                <OnBoardingNav />
                <div className="customers-outer">
                    <div className="team-divider">
                    <p className="team-title">Our Customers Love GPS DataViz</p>
                        <div className="team-grid">
                            <div className="customers-box">
                            <p className="quote-description">“GPS DataViz is a necessity: it provides coaching staffs with the knowledge they need to make great decisions surrounding the well-being of their players.”</p>
                            <div className="person-divider"><Divider></Divider></div>
                            <p className="person-title">Director of Strength and Conditioning for a USA Olympic Team</p>
                            </div>
                            <div className="customers-box">
                                <p className="quote-description">“GPS DataViz gives us exactly the insights we want quickly. The information given actually impacts how we coach and interact with players.”</p>
                                <div className="person-divider"><Divider></Divider></div>
                                <p className="person-title">Division I Women’s Soccer Head Coach</p>
                            </div>
                            <div className="customers-box">
                            <p className="quote-description">“Want to thank you for the platform: our players were ready to compete each game and felt fresh the whole year. GPS DataViz is so easy to use and explain to the staff and players why we were doing what we were doing.”</p>
                            <div className="person-divider"><Divider></Divider></div>
                            <p className="person-title">Power 5 Division I Men’s Soccer Associate Head Coach</p>
                            </div>
                        </div>
                    </div>
                    <div className="search-divider"><Divider></Divider></div>
                    <br/>
                    <br/>
                    <br/>
                </div>
            </div>
        </>
    }
}